import { ISelectOption } from '@principle-theorem/shared';

export const ACC_DOCUMENT_DATETIME_FORMAT = 'yyyyMMddHHmmss';
export const ACC_DOCUMENT_DATE_FORMAT = 'DD-MM-YYYY';

export enum AccDocumentStatus {
  Receipted = 'Receipted',
}

export enum AccDocumentContentType {
  ComponentryInvoices = 'DN-COMPONENTRYINVS',
  ConsentForm = 'DN-ACC6300CONSENT',
  DentalARTP = 'DN-ACC8298DARTP',
  GAPriorApprovalViaLetter = 'DN-GAPRIORAPPROVAL',
  IncomingFromClaimant = 'DN-INVRECFRMCLIENT',
  InvoiceNonSpecialists = 'DN-PROVIDERDENTALINV',
  InvoiceSpecialist = 'DN-SPECINVOICE',
  LetterFromClient = 'DN-LETTERFROMCLIENT',
  LetterFromGPOrProvider = 'DN-LETTERFROMPROV',
  MedicalRecordsNotes = 'DN-MEDREPTNOTES',
  PhotoXrays = 'DN-PHOTOPAOPGXRAY',
  PriorApprovalViaLetter = 'DN-PRIORAPPROVAL',
}

export const ACC_DOCUMENT_CONTENT_TYPE_OPTIONS: ISelectOption<AccDocumentContentType>[] =
  [
    {
      label: 'Consent Form',
      value: AccDocumentContentType.ConsentForm,
    },
    {
      label: 'Dental ARTP',
      value: AccDocumentContentType.DentalARTP,
    },
    {
      label: 'GA Prior Approval via letter',
      value: AccDocumentContentType.GAPriorApprovalViaLetter,
    },
    {
      label: 'Incoming from claimant (Receipts/Invoices)',
      value: AccDocumentContentType.IncomingFromClaimant,
    },
    {
      label: 'Invoice (non-specialists)',
      value: AccDocumentContentType.InvoiceNonSpecialists,
    },
    {
      label: 'Invoice (specialist)',
      value: AccDocumentContentType.InvoiceSpecialist,
    },
    {
      label: 'Letter from Client',
      value: AccDocumentContentType.LetterFromClient,
    },
    {
      label: 'Letter from GP or Provider',
      value: AccDocumentContentType.LetterFromGPOrProvider,
    },
    {
      label: 'Medical records/notes',
      value: AccDocumentContentType.MedicalRecordsNotes,
    },
    {
      label: 'Photo / X-rays',
      value: AccDocumentContentType.PhotoXrays,
    },
    {
      label: 'Prior Approval via letter',
      value: AccDocumentContentType.PriorApprovalViaLetter,
    },
  ];

export interface IAccDocumentMetadata {
  contentType: AccDocumentContentType;
  fileCreationDateTime?: string;
  runId?: string; // e.g., '666666'
  claimReferenceNumber: string; // e.g., 'AC344433'
  consultingProviderName?: string;
  dateOfConsult?: string; // Format: 'DD-MM-YYYY'
  metaDataForContentType?: string;
  assessmentType?: string;
  bodySite?: string;
  clientNHINumber?: string;
  clientFirstName: string;
  clientLastName: string;
  clientDOB: string; // Format: 'DD-MM-YYYY'
  fileExtension: string; // e.g., 'PDF'
}
